import "../style/default.css";
import "../style/home.css";

import couriers from "../assets/couriers.jpg";
import grab from "../assets/grab.png";

function Services() {
  return (
    <div className="Services">
      <div className="services_grid">
        <div className="grid_text">
          <span className="biggest-text">24/7</span>
          <h2>SAME DAY SHIPPING AVAILABLE</h2>
          <p className="sub-header">
            Order anytime within the day and night we'll have your orders
            shipped ASAP!
            <br />
            We can ship using Grab, Lalamove, Move It, or Angkas whichever you
            prefer!
            <br />
            We can also book the courier so less hassle on your part.
            <br />
            Totally cashless transactions!
            <br />
            <br />
            NO HOLIDAYS! WE SHIP OUT 24 HOURS A DAY 7 DAYS A WEEK!
          </p>
        </div>
        <div className="grid_img">
          <img src={couriers} alt="Couriers"></img>
        </div>
      </div>
    </div>
  );
}

export default Services;
